module.exports = __webpack_public_path__ + "img/movies-bg-over.dd05c49d.png";